module.exports = __webpack_public_path__ + "static/media/powered-wolly-logo-blanco.2478a471.png";